import React from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/navigation/web/Navbar";
import ForecastHome from "../../components/Forecast/ForecastHome";

const Forecast = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("forecast.title"),
					component: <ForecastHome />,
				}}
				right={null}
			/>
		</>
	);
};

export { Forecast };
